const trackEvent = (name, valueCents) => {
  if (typeof window === 'undefined' || !window.fathom) return;
  if (typeof valueCents === 'number' && Number.isFinite(valueCents)) {
    window.fathom.trackEvent(name, { _value: Math.round(valueCents) });
  } else {
    window.fathom.trackEvent(name);
  }
};

export default trackEvent;
